import React, { forwardRef, PropsWithChildren } from 'react';

import styles from './MatchesContainer.module.scss';

// ---

const MatchesContainer = forwardRef<HTMLDivElement, PropsWithChildren>(({ children }, ref) => {
  return (
    <div id="matches-container"
         ref={ref}
         className={styles.matchesContainer}>
      {children}
    </div>
  );
});

export default MatchesContainer;
